import { render } from "./dashboardTabComponent.vue?vue&type=template&id=643f410d"
import script from "./dashboardTabComponent.vue?vue&type=script&lang=js"
export * from "./dashboardTabComponent.vue?vue&type=script&lang=js"

import "./dashboardTabComponent.vue?vue&type=style&index=0&id=643f410d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__